module.exports = __webpack_public_path__ + "static/img/logo-yd.5bfd4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-yd.png
// module id = 63
// module chunks = 1